import { ImageConfig } from 'hooks/test/use-test-7995/config';
import { ShopifyImage } from 'interfaces/product';

type insertImage = {
  target: ShopifyImage[];
  configImage: ImageConfig;
  alt: string;
};

/**
 * Insert images in target array using position
 */
export function insertImage({
  target,
  configImage,
  alt,
}: insertImage): ShopifyImage[] {
  const image: ShopifyImage = {
    id: `mood-image-${configImage.imageName}`,
    originalSrc: `/images/pt-7995/${configImage.imageName}`,
    altText: alt,
  };

  const result = [...target];

  const insertIndex = Math.max(
    0,
    Math.min(configImage.position - 1, result.length)
  );
  result.splice(insertIndex, 0, image);

  return result;
}
